<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="客服昵称" prop="userName">
          <el-input v-model="dataForm.userName" placeholder="客服昵称"></el-input>
      </el-form-item>
          <el-form-item label="二维码" prop="webchatUrl">
          <el-input v-model="dataForm.webchatUrl" placeholder="二维码"></el-input>
      </el-form-item>
          <el-form-item label="微信号" prop="webchatCode">
          <el-input v-model="dataForm.webchatCode" placeholder="微信号"></el-input>
      </el-form-item>
          <el-form-item label="微信昵称" prop="webchatName">
          <el-input v-model="dataForm.webchatName" placeholder="微信昵称"></el-input>
      </el-form-item>
          <el-form-item label="手机号" prop="mobilePhone">
          <el-input v-model="dataForm.mobilePhone" placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
          <!-- <el-input v-model="dataForm.status" placeholder="状态：0启用 1禁用"></el-input> -->
          <el-select  v-model="dataForm.status" filterable clearable  placeholder="请选择状态">
                  <el-option
                          v-for="item in statusList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
          <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
      <el-form-item label="添加时间" prop="addTime">
         
          <el-date-picker
                  v-model="dataForm.addTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      statusList:[
          {
            value: 0,
            label:'启用'
          },
          {
            value: 1,
            label:'禁用'
          }
        ],
      dataForm: {
        id: '',
        userName: '',
        webchatUrl: '',
        webchatCode: '',
        webchatName: '',
        mobilePhone: '',
        status: '',
        remark: '',
        addTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        userName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        webchatUrl: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        webchatCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        webchatName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mobilePhone: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        addTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/slcustomer/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/slcustomer/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
